import {
  GET_LIST_NOPHAITHU,
  GET_LIST_NOPHAITHU_SUCCESS,
  GET_LIST_NOPHAITHU_FAILURE,
} from "./actionTypes";

export const getListNoPhaiThu = (dataSearch) => ({
  type: GET_LIST_NOPHAITHU,
  dataSearch,
});

export const getListNoPhaiThuSuccess = (data) => ({
  type: GET_LIST_NOPHAITHU_SUCCESS,
  payload: data,
});

export const getListNoPhaiThuFailure = () => ({
  type: GET_LIST_NOPHAITHU_FAILURE,
});
